// Base URL for the PHP backend. Set via REACT_APP_API_BASE_URL (see
// .env.development / .env.production) so dev and production builds point at
// the right server without touching this file.
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost/BACKEND";

// Attaches the admin session token (set by Login.jsx) to a request. Spread
// into an axios headers object for any endpoint that requires auth.
export function authHeaders() {
  const token = localStorage.getItem("someToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// Turns a relative path returned by the backend (e.g. "uploads/portfolio/x.jpg")
// into a URL the browser can load.
export function assetUrl(path) {
  return `${API_BASE_URL}/${path}`;
}
